import * as React from 'react';
import { Button, ButtonTypes } from 'common/components/core/button';
import { Carton } from 'common/models/internal/Carton';
import { Section } from 'common/entity/generic/SingleEntityEditView';
import { themr } from 'react-css-themr';

import classnames from 'classnames';
import defaultTheme from './LineItemPartsInput.scss';
import CustomColumnHelpers from 'common/entity/helpers/CustomColumnHelpers';
import CartonInput from 'common/entity/components/carton/CartonInput';
import LineItemTestIds from 'common/entity/lineItemMaster/LineItemTestIds.json';

class LineItemCartonInput extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            carton: props.carton,
            shouldConvertToPreferredUnit: true
        };
    }

    componentDidMount() {
        const { shouldConvertToPreferredUnit } = this.state;
        shouldConvertToPreferredUnit &&
            this.setState({ carton: this.getUpdatedCartonByUnit() });
    }

    componentDidUpdate(prevProps) {
        const { carton } = this.props;
        const { shouldConvertToPreferredUnit } = this.state;
        if (prevProps.carton !== carton) {
            shouldConvertToPreferredUnit
                ? this.setState({ carton: this.getUpdatedCartonByUnit() })
                : this.setState({ carton });
        }
    }

    getUpdatedCartonByUnit = () => {
        const { carton, unitConverter } = this.props;
        return carton?.convertToPreferredUnit(unitConverter);
    };

    handleBoxDetailsDelete = () => {
        this.onChange(null);
        this.setState({ carton: null, shouldConvertToPreferredUnit: false });
    };

    onCartonDetailsAddClick = () => {
        const carton = Carton.defaultInit({});
        this.onChange(carton);
    };

    onChange = carton => {
        const { onChange } = this.props;

        this.setState({ carton, shouldConvertToPreferredUnit: false }, () => {
            onChange && onChange(carton);
        });
    };

    render() {
        const {
            theme,
            hiddenModelProperties,
            lineItem,
            translationsObject,
            t
        } = this.props;
        const { carton } = this.state;
        if (hiddenModelProperties.includes('carton')) {
            return null;
        }
        const hiddenCartonSubFields = CustomColumnHelpers.getHiddenPropertySubFields(
            {
                key: 'carton',
                hiddenModelProperties
            }
        );

        return (
            <>
                {!carton?.volume ? (
                    <span
                        className={theme.addText}
                        onClick={this.onCartonDetailsAddClick}
                        data-test-id={LineItemTestIds.addBoxDetails}
                    >
                        + {t(translationsObject.addBtnText)}
                    </span>
                ) : null}
                {carton?.volume ? (
                    <Section>
                        <div className={theme.cartonInputWrap}>
                            <Button
                                buttonType={ButtonTypes.Icon}
                                circle
                                icon="delete-bin"
                                className={classnames(
                                    theme.btn,
                                    theme.deleteBtn
                                )}
                                theme={theme}
                                onClick={this.handleBoxDetailsDelete}
                            />
                            <CartonInput
                                translationsObject={translationsObject}
                                theme={theme}
                                onChange={this.onChange}
                                lineItem={lineItem}
                                defaultValue={carton}
                                hiddenCartonSubFields={hiddenCartonSubFields}
                            />
                        </div>
                    </Section>
                ) : null}
            </>
        );
    }
}

export default themr('LineItemCartonInput', defaultTheme)(LineItemCartonInput);
